export const Action = {  
  CREATE_SCHEDULE: "CREATE_SCHEDULE",
  DELETE_SCHEDULE: "DELETE_SCHEDULE",
  UPDATE_SCHEDULE: "UPDATE_SCHEDULE"
};

export const Mutation = {
  SET_SCHEDULES: "SET_SCHEDULES"
};

export const Getter = {
  GET_SCHEDULES: "GET_SCHEDULES"
};
